import React from 'react';

class Outline extends React.Component {
    constructor(props) {
        super(props)

        var sample_pics = [
            'sunset.jpg',
            'mushroom.jpg',
            'sunflower.jpg'
        ]              

        var leads =   [
            {
              "hardness": "9B",
              "score": 13
            },
            {
              "hardness": "8B",
              "score": 26
            },
            {
              "hardness": "7B",
              "score": 39
            },
            {
              "hardness": "6B",
              "score": 52
            },
            {
              "hardness": "5B",
              "score": 65
            },
            {
              "hardness": "4B",
              "score": 78
            },
            {
              "hardness": "3B",        
              "score": 91
            },
            {
              "hardness": "2B",
              "score": 104
            },
            {
              "hardness": "B",
              "score": 117
            },
            {
              "hardness": "HB",
              "score": 130
            },
            {
              "hardness": "F",
              "score": 143
            },
            {
              "hardness": "H",
              "score": 156
            },
            {
              "hardness": "2H",
              "score": 169
            },
            {
              "hardness": "3H",
              "score": 182
            },
            {
              "hardness": "4H",      
              "score": 195
            },
            {
              "hardness": "5H",
              "score": 208
            },
            {
              "hardness": "6H",
              "score": 221
            },
            {
              "hardness": "7H",
              "score": 234
            },
            {
              "hardness": "8H",
              "score": 247
            },
            {
              "hardness": "9H",
              "score": 260
            }
          ]

        var p = ['9B','8B','7B','6B','5B','4B','3B','2B','B','HB','F','H','2H','3H','4H','5H','6H','7H','8H','9H']
          
        this.state = {pic_name:'', pencils: p, app_mode: 'home', linedrawn: false, leads: leads,art_type: 'paint',canvas: null,shade_type: 'paint',isLoaded: false, maincolors: null, colors:null,image: null, bwimage:null, colimage:null, coord: null, hex:null, clicked_color:'white', mode: 'init',queuedImg:null, sample_pics:sample_pics, sample_x:0, hist:null, paper_orientation:''}
    }

    componentDidMount () {

        // manage dynamic page scroll based on device type
        if(window.sessionStorage.getItem('device-type') === 'normal') {
            document.body.style.overflow = 'hidden'
        }
        else {
            document.body.style.overflowX = 'hidden'
        }

        // configure drag events for opening picture file
        window.addEventListener('resize', this._handleWindowResize);
        ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (event) {
            document.getElementById('drag_files').addEventListener(event, function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                });
            });
        ['dragover', 'dragenter'].forEach(function (event) {
            document.getElementById('drag_drop_visible').addEventListener(event, function () {
                document.getElementById('drag_drop_visible').classList.add('dragover');
            });
        });
        ['dragleave', 'dragend', 'drop'].forEach(function (event) {
            document.getElementById('drag_drop_visible').addEventListener(event, function () {
                document.getElementById('drag_drop_visible').classList.remove('dragover');
            });
        });

        // configure default blank working images
        var i = new Image()
        this.setState({image: i, bwimage: i, colimage: i})

        
        // get data for primary/secondary/tertiary/quaternary color set
        fetch("main_colors.json")
        .then(response => response.json())
        .then(
            (result) => {
                this.setState({maincolors: result})
            },
            (error) => {
                console.log("maincolor read fail" + error)
                this.setState({isLoaded:true,
                error})
            }
        )

        // get data for all colors 
        fetch("colors.json") 
        .then( response => response.json())
        .then(
            // handle the result
            (result) => {
                this.setState({
                    isLoaded : true,
                    colors : result
                }, this._handleWindowResize);
            },

            // Handle error 
            (error) => {
                console.log("color read fail:" + error)
                this.setState({
                    isLoaded: true,
                    error
                })
            },
        )

    }
    

    componentWillUnmount() {
        window.removeEventListener('resize', this._handleWindowResize);
    }


    _handleWindowResize = (event) => {

        try {
            var canvas = document.getElementById("target")
            var wk_area = document.getElementById('wk_area')

            var w = window.innerWidth

            // if no image selected
            if(this.state.pic_name === '') {
                
                // scale width of home pic and header..

                // get actual width of home picture
                var homepic_width = document.getElementById('demo_image').naturalWidth
                
                // deduct width of control column
                var expected_width = w - 200

                // if not small device
                if(window.sessionStorage.getItem("device-type") === "normal") {
                    
                    // deduct width of skyscraper ad
                    expected_width -= 400
                }

                // stretch home pic and demo banner to fit
                if(homepic_width > expected_width) {
                    document.getElementById('demo_image').style.width = expected_width + 'px'
                    document.getElementById('demo_header').style.width = expected_width + 'px'
                    console.log("shrinking.homepic:" + expected_width)
                }
                else {
                    document.getElementById('home_pic').style.width = homepic_width + 'px'
                    
                }
            }
            
            let close_button_offset = 40
            // make products fill width for small screens
            if(window.sessionStorage.getItem("device-type") === "small") {
                
                // prepare to set canvas area width for small device

                // scale product images
                let prodw = window.innerWidth - 115
                let ims = document.getElementsByClassName('product-images-mo')
                for(var x=0; x<ims.length; x++) {
                    ims[x].style.width = prodw + 'px'
                }
                close_button_offset = 140
            }
            else {

                // prepare to set canvas area width for normal device
                // .. making room for ads
                //w = w * .45
                w = w * .75
            }

            // set canvas area width
            var h = window.innerHeight
            var d = this.imgSizeFit(this.state.image, w, h)
            var cw = d.width
            var ch = d.height
            canvas.width = cw
            canvas.height = ch
            wk_area.style.width = cw + 'px'
            wk_area.style.height = ch + 'px'

            // if a picture is open
            if(this.state.pic_name !== '') {
                // manage placement of 'close picture' button
                var bwid = cw - close_button_offset

                document.getElementById('close_pic_button').style.left = bwid + 'px'
            }

            
            var ctx = canvas.getContext("2d");

            // apply contrast filter to canvas if the option is checked
            if(this.state.linedrawn) {
                ctx.filter = "url(#line-art)"
            }

            ctx.drawImage(this.state.image, 0,0, cw, ch)

        }
        catch(e) {
            console.log("resize.err:" + e)
        }


    }


    showPencilConfig = () => {
        document.getElementById('pencil_pane').style.display = 'flex'
    }


    navSampleBack = (e) => {
        // manage reverse navigation through sample pictures
        e.preventDefault()
        var x = this.state.sample_x
        if(x === 0) {
            x = this.state.sample_pics.length - 1
        }
        else {
            x--
        }
        var p = this.state.sample_pics[x]
        document.getElementById('demo_image').src= p
        this.setState({sample_x: x})

    }

    navSampleFwd = (e) => {
        // manage forward navigation through sample pictures
        e.preventDefault()
        var x = this.state.sample_x
        if(x === this.state.sample_pics.length - 1) {
            x = 0
        }
        else {
            x++
        }
        var p = this.state.sample_pics[x]
        document.getElementById('demo_image').src= p
        this.setState({sample_x: x})

    }

    draw_sample = (e) => {
        // choose a sample picture
        e.preventDefault()
        var p = this.state.sample_pics[this.state.sample_x]
        this.setState({queuedImg: p}, this.onImageChange)
    }

    imgSizeFit = (img, maxWidth, maxHeight) => { 
        // calculate dimensions of passed image using maximum thresholds
        // .. used to size the canvas appropriately

        var ratio = Math.min(1, maxWidth / img.naturalWidth, maxHeight / img.naturalHeight)
        var w = img.naturalWidth * ratio
        var h = img.naturalHeight * ratio

        return {width: w, height:h}
    }

    onImageChange = (event) => {
        // triggered once user chooses a picture
        try {
            event.preventDefault()
        }
        catch(e) {
            // pass
        }


        // prepare to manage pic file
        var ifiles = null

        // aquire file dragged onto  target
        if(event && event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0]) {
            ifiles = event.dataTransfer.files
        }

        // aquire file chosen with file dialog
        if (ifiles === null && event && event.target.files && event.target.files[0]) {
            ifiles = event.target.files
        }

        console.log("pre.fok.1")
        var file_ok = false
        var i = null
        var pic_nm = ''

        // collect path and name of any dropped/chosen pic file
        if(ifiles) {
            file_ok = true
            i = this.state.image
            i.src = URL.createObjectURL(ifiles[0])
            pic_nm = ifiles[0].name
            this.setState({pic_name: pic_nm})
        }


        // collect name/path if user selected sample picture
        if(this.state.queuedImg) {
            file_ok = true
            i = new Image()
            pic_nm = this.state.queuedImg 
            i.src = pic_nm
            this.setState({image:i, pic_name: pic_nm})
        }

        // apply default label for paper config button
        document.getElementById('config_ok').innerText = 'OK'


        // grab and populate any paper configs into inputs
        if(this.state.paper) {
            
            let confs = this.state.paper[pic_nm]
            if(confs) {
                let marg = confs[confs.length-1]
                let ph = confs[confs.length-2]
                let pw = confs[confs.length-3]
                document.getElementById('margin_size').value = marg
                document.getElementById('paper_size_w').value = pw
                document.getElementById('paper_size_h').value = ph
                
                // updated button label for existing configs
                document.getElementById('config_ok').innerText = 'Confirm'
            }
        }

        
        // if a file was recognized
        if(file_ok) {
            
            
            let draw_mode = 'init'

            // hide homepage elements
            document.getElementById('home_pic').style.display = 'none'
            document.getElementById('header_boundary').style.display = 'none'
            document.getElementById('demo_boundary').style.display = 'none'

            // hide color/shade assist elements
            document.getElementById('splash').style.display = 'none'
            document.getElementById('opt_area').style.display = 'none'
            document.getElementById('shade_tree').style.display = 'none'
            document.getElementById('sketch_tree').style.display = 'none'
            document.getElementById('splash_text').style.display = 'none'

            // prepare image workspace
            document.getElementById('wk_area').style.width='400px'
            document.getElementById('pic_load_info').style.display = 'block'

            if(window.sessionStorage.getItem("device-type") === "small") {
                document.getElementById('mo_sketching_finishing').style.display = 'flex'
                document.getElementById('wk_area').style.display = 'none'
                document.getElementById('ctrl_area').style.display = 'none'
                
            }
            else {
                // prepare sketch instruction/measurement area
                document.getElementById('pic_mm').style.display = 'block'		   
                document.getElementById('pic_mm').innerText = ''
            }



            // once image is loaded.. prepare and display
            i.onload = () => {
                
                // get original image dimensions
                var w = i.naturalWidth
                var h = i.naturalHeight

                // size workspace to accomodate image
                var canvas = document.getElementById("target")
                var wk_area = document.getElementById('wk_area')
                canvas.width = w
                canvas.height = h
                wk_area.style.width = w + 'px' 
                wk_area.style.height = h + 'px'
                
                // output image 
                var ctx = canvas.getContext("2d");
                ctx.drawImage(i, 0, 0);

                // prepare greyscale version of image
                var imgPixels = ctx.getImageData(0, 0, w, h);
                for(var y = 0; y < imgPixels.height; y++){
                    for(var x = 0; x < imgPixels.width; x++){
                        var ii = (y * 4) * imgPixels.width + x * 4;
                        var avg = (imgPixels.data[ii] + imgPixels.data[ii + 1] + imgPixels.data[ii + 2]) / 3;
                        imgPixels.data[ii] = avg; 
                        imgPixels.data[ii + 1] = avg; 
                        imgPixels.data[ii + 2] = avg;
                    }
                }
                ctx.putImageData(imgPixels, 0, 0, 0, 0, w, h);
                var n = new Image()
                var p = canvas.toDataURL();
                n.src = p
                
                // retain images and canvas 
                this.setState({canvas: ctx, bwimage: n, colimage: i})
                
                // show 'sketching / finishing' buttons
                document.getElementById("type_buttons").style.display = 'block'
                
                // trigger resize to manage image scaling
                this._handleWindowResize(event)
                
                // display close button for image
                document.getElementById('close_pic_button').style.display = 'flex'
                
                // hide 'loading..' indicator
                document.getElementById('pic_load_info').style.display = 'none'

                // detect if picture should be landscape mode.. swap paper dims
                if(w > h) {
                    document.getElementById('drawing_mode').src = 'landscape_mode.png'
                    draw_mode = 'landscape'
                }
                else {
                    document.getElementById('drawing_mode').src = 'portrait_mode.png'
                    draw_mode = 'portrait'
                }
                this.setState({paper_orientation: draw_mode})
                
            }
        
        
            try {
                event.target.value = ''
            }
            catch(e) {
                //pass
            }
            

            this.setState({queuedImg: null, shade_type: 'paint', linedrawn: false})
        }
    }

    toggleLinedrawn = () => {
        // triggered when user checks 'contrast' option
        var r = false
        if(this.state.linedrawn) {
            r = false
        }
        else {
            r = true
        }
        this.setState({linedrawn: r}, this._handleWindowResize)
    } 

    finishPic = (e) => {
        // triggered when user clicks 'finishing' after loading a picture

        e.preventDefault()

        document.getElementById('mo_sketching_finishing').style.display = 'none'
        
        // hide sketching elements
        document.getElementById('whatcha_doin_label').style.display = 'none'
        document.getElementById('sketch_tree').style.display = 'none'
        document.getElementById('pic_mm').innerText = ''
        document.getElementById('drawing_mode').style.display = 'none'
        document.getElementById('pic_mm').style.display = 'none'

        // configure and show color assist elements
        document.getElementById('opt_area').style.display = 'block'
        document.getElementById('shade_tree').style.display = 'block'
        document.getElementById('color_pane').style.backgroundColor = 'white'
        document.getElementById('color_desc').innerText = ''
        document.getElementById('finish_button').className = 'menu_button'
        document.getElementById('sketch_button').className = 'menu_button'
        
        this.apply_shade(e, 'paint', false)

        this.setState({mode:'finish', linedrawn:false, art_type:'paint', shade_type:'paint'}, this._handleWindowResize)

        if(window.sessionStorage.getItem("device-type") === "small") {
            document.getElementById('wk_area').style.display = 'none'
            document.getElementById('mo_paint_pencil').style.display = 'flex'
            document.getElementById('go_finishing').style.display = 'none'
        }
        else {
            document.getElementById('click_hint').style.display = 'block'
        }

    }


    sketchPic = (e) => {
        // triggered when user clicks 'sketching' after loading a picture

        e.preventDefault()

        document.getElementById('mo_sketching_finishing').style.display = 'none'

        // hide finishing elements
        document.getElementById('whatcha_doin_label').style.display = 'none'
        document.getElementById('opt_area').style.display = 'none'
        document.getElementById('shade_tree').style.display = 'none'
		document.getElementById('drawing_mode').style.display = 'none'
        document.getElementById('pic_mm').style.display = 'none'

        // configure and show sketching elements
        document.getElementById('config_pane').style.display = 'flex'
        document.getElementById('config_pane').style.zIndex = 899
        document.getElementById('finish_button').className = 'menu_button'
        document.getElementById('sketch_button').className = 'menu_button'
												  
        this.setState({mode:'sketch',linedrawn:false})
        
        // reset finishing mode to paint.. so pic is not greyscale
        this.switch_shades()

        if(window.sessionStorage.getItem("device-type") === "small") {
            document.getElementById('go_sketching').style.display = 'none'
        }

        document.getElementById('click_hint').style.display = 'none'
    }
    
    choose_common_paper = () => {
        // triggered when user selects choice from common paper sizes
        
        // populate inputs with chosen sizes
        var sel_val = document.getElementById('common_paper_sz').value
        var sp_val = sel_val.split(' x ')
        document.getElementById('paper_size_w').value = sp_val[0]
        document.getElementById('paper_size_h').value = sp_val[1]
        
    }

    getColorName = (ired,igreen,iblue) => {
        // get best matching color name

        var c = this.state.colors
        var min = 10000
        var r = ''

        // loop through color data
        for(var x=0; x<c.length; x++){

            // calculate the total difference between passed color RGB and loop item
            let d = Math.abs(ired - c[x].red) + Math.abs(igreen - c[x].green) + Math.abs(iblue - c[x].blue)

            // retain and track where lowest difference so far
            if(d<=min) {
                min = d
                r = c[x].name.replace(/_/g, ' ')
            }
        }
        return this.toTitleCase(r)
    }

    toTitleCase = (str) => {
        // Makes Each Word In Passed String Have Uppercase First Letter
        return str.toLowerCase().split(' ').map(function (word) {
          return (word.charAt(0).toUpperCase() + word.slice(1));
        }).join(' ');
      }

    getMainColor = (ired,igreen,iblue) => {
        // get closest matching primary/secondary/tertiary/quaternary color

        // catch BLACK / WHITE
        if(ired === 0 && igreen === 0 && iblue === 0) {
            return 'Black'
        }
        if(ired === 255 && igreen === 255 && iblue === 255) {
            return 'White'
        }
        
        var c = this.state.maincolors
        var min = 10000
        var r = ''

        // loop through main-colors data
        for(var x=0; x<c.length; x++){

            // calculate the total difference between passed color RGB and loop item
            let d = Math.abs(ired - c[x].red) + Math.abs(igreen - c[x].green) + Math.abs(iblue - c[x].blue)
            
            // retain and track where lowest difference so far
            if(d<=min) {
                min = d
                r = c[x].desc.replace('_', ' ')
            }
        }
        return r
    }


    getMix = (icolor, xtra) => {
        // build tip syntax for RBY pigment mixing of targeted color

        // modify syntax where lighten/darken option was included
        if(xtra !== '') {
            xtra = ' and ' + xtra
        }

        // catch WHITE/BLACK (no mixing required)
        if (icolor === 'Black') 
            return 'Use black'
        if (icolor === 'White')
            return 'Use white'

        // catch PRIMARY colors (no mixing)
        if (icolor === 'Red')
            return 'Primary red' + xtra
        if (icolor === 'Blue')
            return 'Primary blue' + xtra
        if (icolor === 'Yellow')
            return 'Primary yellow' + xtra

        // describe how to mix based on passed primary/secondary/tertiary/quaternary color
        // .. once that is achieved on the palette..
        // ..  it should be relatively obvious what color addition is necessary to match target
        if (icolor === 'Green')
            return 'Start with yellow' + xtra + '\n\n.. add some blue'
        if (icolor === 'Orange')
            return 'Start with yellow' + xtra + '\n\n.. add some red'
        if (icolor === 'Violet')
            return 'Start with red' + xtra + '\n\n.. add some blue'
        if (icolor === 'Purple')
            return 'Start with blue' + xtra + '\n\n.. slowly add red'
        if (icolor === 'Teal')
            return 'Start with blue' + xtra + '\n\n.. slowly add yellow'
        if (icolor === 'Charteuse')
            return 'Start with yellow' + xtra + '\n\nslowly add blue'
        if (icolor === 'Amber')
            return 'Start with yellow' + xtra + '\n\nslowly add red'
        if (icolor === 'Vermilion')
            return 'Start with red' + xtra + '\n\nslowly add yellow'
        if (icolor === 'Magenta')
            return 'Start with red' + xtra + '\n\nslowly add blue'
        if (icolor === 'Brown')
            return 'Start with red' + xtra + '\n\nadd some yellow \n\nslowly add blue '
        if (icolor === 'Slate')
            return 'Start with red' + xtra + '\n\nslowly add yellow and blue '
        if (icolor === 'Olive')
            return 'Start with yellow' + xtra + '\n\nslowly add red and blue '
        if (icolor === 'Coffee')
            return 'Start with red' + xtra + '\n\nadd some yellow \n\nslowly add blue '
        if (icolor === 'Cedar')
            return 'Start with blue' + xtra + '\n\nslowly add red and yellow '
        if (icolor === 'Sage')
            return 'Start with blue' + xtra + '\n\nslowly add yellow and red '
    
    }
    


    switch_shades = (e) => {
        // triggered when user clicks 'pencil' or 'paint' radio option buttons

        // identify which option

        var a_type = 'paint'
        try{
            if(e.target.value === 'pencil') {
                a_type = 'pencil'
            }
        }
        catch(e) {
            // pass
        }

        this.apply_shade(e, a_type, false)


        
    }

    apply_shade(e, a_type, is_button) {
        console.log("ATYPE:" + a_type)

        if(is_button) {
            try {
                e.preventDefault()
            }
            catch(e) {
                //pass
            }
        }

        
        var i = null
        // clear any color/shade assist details output previously
        document.getElementById('color_pane').style.backgroundColor = 'white' 
        document.getElementById('bw_shades').innerText = ''
        document.getElementById('color_desc').innerText = ''
        document.getElementById('color_name').innerText = ''        
        if(a_type === 'pencil') {

            // display shade assist elements
            document.getElementById('color_shades').style.display = 'none'
            document.getElementById('bw_shades').style.display = 'block'
            document.getElementById('pencil_conf_lnk').style.display = 'flex'
            document.getElementById('three_shades').style.display = 'flex'
            
            // aquire greyscale image
            i = this.state.bwimage

        }
        else {

            // display color assist elements
            document.getElementById('color_shades').style.display = 'block'
            document.getElementById('bw_shades').style.display = 'none'
            document.getElementById('pencil_conf_lnk').style.display = 'none'													 
            document.getElementById('three_shades').style.display = 'none'

            // aquire color image
            i = this.state.colimage
        }
        
        
        this.setState({art_type: a_type,shade_type: a_type, image: i}, this._handleWindowResize)

        if(window.sessionStorage.getItem("device-type") === "small") {
            document.getElementById('mo_paint_pencil').style.display = 'none'


            document.getElementById('explain_finishing').style.display = 'block'
            // document.getElementById('wk_area').style.display = 'block'
            // document.getElementById('go_sketching').style.display = 'block'



        }
        
    }

    choosePic = (e) => {
        // used to trigger hidden 'file' input
        e.preventDefault()
        document.getElementById('chooser').click()
    }

    hideCookieWarning = (e) => {
        e.preventDefault()
        document.getElementById('cookie_area').style.display='none'
        window.sessionStorage.setItem("cookie-okayed","ok")
    }

    isNumeric = (str) => {
        if (typeof str != "string") return false  
        return !isNaN(str) && 
               !isNaN(parseFloat(str))
      }

    config_ok = (e) => {
        // triggered when user clicks 'ok' or 'confirm' while configuring paper details

        e.preventDefault()

        
        var bm = document.getElementById('margin_size').value
        var paper_h = document.getElementById('paper_size_h').value
        var paper_w = document.getElementById('paper_size_w').value

        console.log("W:" + paper_w + " H:" + paper_h + " M:" + bm)

        if(!this.isNumeric(paper_w) && paper_w !== '') {
            document.getElementById('paper_warning').innerText = 'Numbers only for width'
            document.getElementById('paper_warning').style.display = 'block'
            return
        }
        if(!this.isNumeric(paper_h) && paper_h !== '') {
            document.getElementById('paper_warning').innerText = 'Numbers only for height'
            document.getElementById('paper_warning').style.display = 'block'
            return
        }
        if(!this.isNumeric(bm) && bm !== '') {
            document.getElementById('paper_warning').innerText = 'Numbers only for margin'
            document.getElementById('paper_warning').style.display = 'block'
            return
        }

        document.getElementById('paper_warning').innerText = ''

        // hide config panel
        document.getElementById('config_pane').style.display = 'none'

        // show buttons for 'sketching' and 'finishing'
        document.getElementById('drawing_mode').style.display = 'block'

        if(this.state.paper_orientation !== '') {

            // tailor instructions to indicate how to hold the sketch paper
            document.getElementById('pic_mm').innerText = "Click on reference points in the picture\n\nUse a ruler to measure that point on your paper\n\nThe sketch orientation will be " + this.state.paper_orientation + " like below\n\n"
        }
        
        // show instructions
        document.getElementById('pic_mm').style.display = 'block'
        
        // show 'contrast' tools if not small device and not safari
        var ua = navigator.userAgent.toLowerCase();
        if(ua.indexOf('safari') !== -1 && window.sessionStorage.getItem("device-type") === "normal") {
            document.getElementById('sketch_tree').style.display = 'block'
        }

        if(window.sessionStorage.getItem("device-type") === "small") {
            document.getElementById('explain_sketching').style.display = 'block'
            document.getElementById('explain_finishing').style.display = 'none'
        }

    }

    clicked_finishing_tree = (e) => {
        document.getElementById("shade_tree_mobile").style.display = 'none'
    }

    explained_finishing_ok = (e) => {
        e.preventDefault()
        document.getElementById('explain_finishing').style.display = 'none'
        document.getElementById('wk_area').style.display = 'block'
        document.getElementById('go_sketching').style.display = 'block'

        
        
    }

    explained_sketching_ok = (e) => {
        e.preventDefault()
        document.getElementById('explain_sketching').style.display = 'none'
        document.getElementById('wk_area').style.display = 'block'
        document.getElementById('go_finishing').style.display = 'block'
    }

    showed_mm_ok = (e) => {
        e.preventDefault()
        document.getElementById('mobile_sketching_mm').style.display = 'none'
    }


    pencils_score = () => {
        // customize pencil hardness data to only include configured ones

        let lds = Object.assign([], this.state.leads);
        let pcl = this.state.pencils
        let s = 0
        let has = []

        // loop through pencil hardness data {"hardness":"8B","score":26}
        Object.keys(this.state.leads).forEach(function(key) {

            if(pcl.indexOf(lds[key].hardness) > -1) {

                // collect indexes of available pencils
                has.push(key)
            }
            else {

                // remove score if pencil not available
                lds[key] = {"hardness": lds[key].hardness, "score": 0}
            }
          });

          // set increment based on how many pencils on hand
          let inc = 260 / has.length

          // loop through available pencil indexes
          for(var x=0; x<has.length; x++){ 
            s += inc

            // set the new score
            let lout = {"hardness":lds[has[x]].hardness, "score": s}
            lds[has[x]] = lout
          }

          this.setState({leads: lds})

    }


    pencil_ok = (e) => {
        // triggered when user clicks 'ok' after checking their available pencils

        e.preventDefault()

        // catch 'nothing checked'
        if(this.state.pencils.length === 0) {
            document.getElementById('pencil_warning').innerText = "You must have at least one pencil type checked"
        }
        else {
            // reset and hide pencil configure panel
            document.getElementById('pencil_warning').innerText = ""
            document.getElementById('pencil_pane').style.display = 'none'
        }
        
        // update pencil score data, so only avaiable pencils are recommended
        this.pencils_score()
    }


    setPencil = (e, p) => {
        // triggered when user clicks one of the 'available pencil' config boxes

        // ensure check element updates
        e.persist();

        // update configured pencils data
        let v = this.state.pencils
        let index = v.indexOf(p);
        if(index === -1) {
            v.push(p)
        }
        else {
            v.splice(index, 1);
            e.target.checked = false
        }
        this.setState({pencils: v})
    }



    paperSpecs = () => {
        // returns paper configuration detail..
        // .. uses default values if not configured

        var bm = document.getElementById('margin_size').value
        if(bm === '') {
            bm = 20 // default margin to 20mm
        }

        var paper_h = document.getElementById('paper_size_h').value
        var paper_w = document.getElementById('paper_size_w').value

        // use default paper size if not config'd - 8 x 10
        if(paper_h === '') {
            paper_h = 254
        }
        if(paper_w === '') {
            paper_w = 203
        }

        return {bm, paper_w, paper_h}

    }


    closePic = () => {
        // triggered when user clicks the close-picture X button

        // clear image from workspace
        var canvas = document.getElementById("target")
        var ctx = canvas.getContext("2d");
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        document.getElementById('wk_area').style.width = '0px'
        canvas.width = 0

        // hide workspace elements
        document.getElementById('opt_area').style.display = 'none'
        document.getElementById('shade_tree').style.display = 'none'
        document.getElementById('sketch_tree').style.display = 'none'
        document.getElementById('close_pic_button').style.display = 'none'
        document.getElementById("type_buttons").style.display = 'none'
        document.getElementById('config_pane').style.display = 'none'
        document.getElementById('drawing_mode').style.display = 'none'
        document.getElementById('pic_mm').style.display = 'none'
        document.getElementById('go_finishing').style.display = 'none'
        document.getElementById('go_sketching').style.display = 'none'

        // configure and show homepage elements
        if(window.sessionStorage.getItem("device-type") === "small") {
            document.getElementById('wk_area').style.display = 'none'
            
            document.getElementById('ctrl_area').style.display = 'flex'
        }
        else {
            document.getElementById('home_pic').style.display = 'block'
            document.getElementById('demo_image').src = 'sunset.jpg' 
            document.getElementById('pic_mm').innerText = ''
            document.getElementById('finish_button').className = 'menu_button'
            document.getElementById('sketch_button').className = 'menu_button'            
        }
        
            document.getElementById('header_boundary').style.display = 'block'
            document.getElementById('demo_boundary').style.display = 'block'
            document.getElementById('splash_text').style.display = 'block'	  


        var i = new Image()
        this.setState({image: i, bwimage: i, colimage: i, pic_name: ''}, this._handleWindowResize)

    }


    onPicClick = (e) => {
        // triggered when user clicks on their picture

        // calculate X,Y of click using event mouse info, and adjusting for any offsets
        var pos = this.findPos(e.target);
        var x = e.pageX - pos.x;
        var y = e.pageY - pos.y;
        x = x - e.target.offsetParent.offsetLeft
        y = y - e.target.offsetParent.offsetTop
        var coord = "x=" + x + ", y=" + y;

        // aquire color of the pixel that was clicked
        var c = e.target.getContext('2d', {willReadFrequently:true});
        var p = c.getImageData(x, y, 1, 1).data; 
        var hex = "#" + ("000000" + this.rgbToHex(p[0], p[1], p[2])).slice(-6);
        
        // catch where user has not chosen 'sketching' or 'finishing' yet
        // .. highlight those buttons
        if(this.state.mode === 'init'){
            document.getElementById('finish_button').className = 'menu_button_glow'
            document.getElementById('sketch_button').className = 'menu_button_glow'
            return
        }
        
        var im = this.state.image

        document.getElementById('click_hint').style.display = 'none'

        // if sketching
        if(this.state.mode === 'sketch') {

            // aquire image dimensions
            var actual_ht = im.naturalHeight     // actual size
            var actual_wd = im.naturalWidth
            var h = e.target.clientHeight // rendered size
            var w = e.target.clientWidth 
            
            // get paper config details
            let {paper_w, paper_h, bm} = this.paperSpecs()
            let lm = bm			 
                
            // detect if picture should be landscape mode
            if(w > h) {

                // swap paper dims
                var tmp = paper_h
                paper_h = paper_w
                paper_w = tmp

                document.getElementById('drawing_mode').src = 'landscape_mode.png'
            }
            else {
                document.getElementById('drawing_mode').src = 'portrait_mode.png'
            }
                        
            
            // set pixel to mm conversion rate
            var pixel_mm_x_rate = 6


            // calculate scaling percent
            var scaled_down_perc = 1
            
            // handle where picture size exceeds the paper size
            if(actual_ht > h || actual_wd > w) {
                var ht_diff = actual_ht - h
                var wd_diff = actual_wd - w

                // calc scaling based on smallest difference
                if(ht_diff < wd_diff) {
                    scaled_down_perc = h / actual_ht
                }
                else {
                    scaled_down_perc = w / actual_wd
                }
            }

            // handle where picture should be blown up to fill the page
            if(actual_ht < h && actual_wd < w) {
                var h_diff = h - actual_ht
                var w_diff = w - actual_wd

                // base on smallest difference
                if(h_diff < w_diff) {
                    scaled_down_perc = h / actual_ht
                }
                else {
                    scaled_down_perc = w / actual_wd
                }
            }
            

            
            
            // calculate conversion rate to consider scaled image
            var conversion = pixel_mm_x_rate
            conversion = conversion * (scaled_down_perc)

            // calculate initial measurements
            var from_left = x / conversion
            var from_bottom = (h - y) / conversion
		

            // prepare to increase margin if (side ..OR top|bottom) is greater than configured due to image size
            // .. to keep aspect correct eg: square pic + rectangular paper
            var margin_enlarged = false
            if(bm > 0) {

                // build expected height of image + config'd margins
                var img_h_mm = actual_ht / pixel_mm_x_rate
                var img_tst = img_h_mm + (2 * bm)

                // if less than paper height
                if(img_tst < paper_h) {

                    // enlarge bottom margin
                    bm = (paper_h - img_h_mm) / 2
                    margin_enlarged = true
                }

                // build expected width of image + config'd margins
                var img_w_mm = actual_wd / pixel_mm_x_rate
                img_tst = img_w_mm + (2 * lm)

                // if less than paper width
                if(img_tst < paper_w) {

                    // enlarge left margin
                    lm = (paper_w - img_w_mm) / 2
                    margin_enlarged = true
                }
            }


            // calculate pixel to mm multiplier using height

            // .. calculate for actual picture size
            var cht = actual_ht / pixel_mm_x_rate

            // .. calculate ideal height of sketch
            var target_height = paper_h - (2 * bm)

            // .. calculate multiplier for ideal height
            var m = target_height / cht
            m = Math.round (m * 100) / 100;

            // catch where sketch height less than available paper height
            if(margin_enlarged) {
                m = 1
            }

            // verify multiplier ok for width
            var cwd = actual_wd / pixel_mm_x_rate
            var tst_w = cwd * m
            if(tst_w > (paper_w - (2 * lm))) {
                
                // too wide.. recalc multiplier based on ideal width
                var target_width = paper_w - (2 * lm)
                m = target_width / cwd
                m = Math.round (m * 100) / 100;
            }

            // recalc bottom margin if needed
            var frottom = h / conversion
            let nhtst = (frottom * m) 
            if(nhtst + (2*bm) < paper_h) {
                bm = (paper_h - nhtst) / 2
                bm = Math.round (bm * 100) / 100;
            }

            // recalc left margin if needed
            var frol = w / conversion
            let otst = (frol * m) 
            if(otst + (2*lm) < paper_w) {
                lm = (paper_w - otst) / 2
                lm = Math.round (lm * 100) / 100;
            }

            // calculate measurement from left edge
            from_left = ( from_left * m ) + parseInt(lm)
            // adjust if slightly over
            if(from_left > target_width+parseInt(lm)) {
                from_left = target_width+parseInt(lm)
            }

            // calculate measurement from bottom edge
            from_bottom = ( from_bottom * m ) + parseInt(bm)
            // adjust if slightly over
            if(from_bottom > target_height+parseInt(bm)) {
                from_bottom = target_height+parseInt(bm)
            }

            // format to single decimal (improves accuracy for sketching tiny areas)
            var left = Math.round(from_left * 10) / 10
            var bottom = Math.round(from_bottom * 10) / 10

            // build and output measurement string
            var measures = "Measure:<br/><br/><strong>" + bottom + "</strong> mm up <br/>from bottom<br/><br/><strong>" + left + "</strong> mm over <br/>from left"
            
            

            
            
            if(window.sessionStorage.getItem("device-type") === "small") {
                document.getElementById('mobile_mm').innerHTML = measures
                document.getElementById('mobile_sketching_mm').style.display = 'block'
            }
            else {
                document.getElementById('pic_mm').innerHTML = measures
            }
            

        }

        // if painting/shading
        if(this.state.mode === 'finish') {

            // get color info
            var ired = p[0]
            var igreen = p[1]
            var iblue = p[2]

            // get and output best match for color name
            var col_nm = this.getColorName(ired,igreen,iblue)
            document.getElementById('color_name').innerText = col_nm

            // apply color to view panel
            document.getElementById('color_pane').style.backgroundColor = hex 

            // clear description panel to prepare for new info
            document.getElementById('color_pane').innerText = ''         
            
            // if preparing color mix hints
            if(this.state.art_type === 'paint') {
    
                // get closest primary/secondary/tertiary/quaternary color
                var col_main = this.getMainColor(ired,igreen,iblue)
                
                // calculate combined values
                var tot = parseInt(ired) + parseInt(igreen) + parseInt(iblue)
                var xtra = ''
                
                // compare combined value with thresholds..
                //.. to determine if result should be darkened, or lightened
                if(tot <= 255) {
                    // darken
                    xtra = 'gray'
                    if(tot <= 150)
                        xtra = 'black'
                }
                if(tot >= 510) {
                    // lighten
                    xtra = 'white'
                }

                // get color mix tip string
                var col_mix = this.getMix(col_main, xtra)

                // catch WHITE result (no mix)
                if(col_nm === 'White') {
                    col_mix = 'White'
                }
                
                // output color mix tip
                document.getElementById('color_desc').innerText = col_mix
            }

            // if preparing pencil type suggestion
            if(this.state.art_type === 'pencil') {
                
                // get closest available pencil suggestion
                var ha = this.bestPencil(iblue)
                
                // build and output suggestion string
                var hardness = this.toTitleCase(ha.desc) + ' pencil: \n\n' + ha.hardness 
                if(col_nm === 'White'){
                    hardness = "Don't shade here"
                }
                document.getElementById('bw_shades').innerText = hardness
                
            }

            // show mobile finishing tip
            if(window.sessionStorage.getItem("device-type") === "small") {
                document.getElementById('shade_tree_mobile').style.display = 'block'
            }
        }
        this.setState({coord: coord, hex: hex})
    }


    pencilDesc = (n) => {
        // returns general description of pencil based on darkness level of passed color

        if(n < 52)
            return 'soft'
        if(n < 104) 
            return 'medium soft'
        if(n < 156)
            return 'medium'
        if(n < 208)
            return 'medium hard'
        if(n < 260)
            return 'hard'
    }

    bestPencil = (n) => {
        // return pencil type suggestion string for passed color value

        // get general description
        var d = this.pencilDesc(n)

        // loop through pencil hardness data
        var c = this.state.leads        
        for(var x=0; x<c.length; x++){

            // return the one with the closest score
            if( c[x].score > n ) {

                if(this.state.pencils.indexOf(c[x].hardness) > -1) {
                    return {desc:d, hardness:c[x].hardness}
                }
            }
        }
        return {desc:d,hardness:''}
    }

    checkPencils = (m) => {
        // uncheck or check all pencil options
        if(m === 'all') {
            let p = ['9B','8B','7B','6B','5B','4B','3B','2B','B','HB','F','H','2H','3H','4H','5H','6H','7H','8H','9H']
            this.setState({pencils: p})
        }
        if(m === 'none') {
            this.setState({pencils: []})
        }
    }


    findPos = (obj) => {
        // return X,Y of passed object considering offsets

        var curleft = 0, curtop = 0;
        if (obj.offsetParent) {
            do {
                curleft += obj.offsetLeft;
                curtop += obj.offsetTop;
            } while (obj === obj.offsetParent);
            return { x: curleft, y: curtop };
        }
        if (!obj.offsetParent) {
            console.log("could not findPos")
        }
        return undefined;
    }

    
    rgbToHex = (r, g, b) => {
        if (r > 255 || g > 255 || b > 255)
            console.log("Invalid color component")
        return ((r << 16) | (g << 8) | b).toString(16);
    }


    doBlur = (e) => {
        // adjust canvas filter based on input from the 'details' slider of the 'contrast' controls
        var blur = document.querySelector("#gaussianBlur");
        blur.setAttribute("stdDeviation",e.target.value);
        this._handleWindowResize()
    }


    doSharpen = (e) => {
        // adjust canvas filter based on input from the 'grains' slider of the 'contrast' controls
        var sharpen = document.querySelector("#fesharpen");
        var n = 28.5 - e.target.value
        n = "-1 -1 -1 -1 " + n + " -1 -1 -1 -1"
        console.log("N:" + n)
        sharpen.setAttribute("kernelMatrix", n);
        this._handleWindowResize()

    }

    render = () => {

        
        
    let title = 'artstrings.ca'

    // configure format and layout adjustments for small devices    
    let sample_controls = 'sample-ctrls'
    let ctrl_area_class = 'ctrl-area'
    let policy_class = 'policy_link'
    let cookie_class = 'cookie-area'
    let home_class = 'home-pic'
    let title_class = 'store-header'
    let config_pane_class = 'configure-pane'
    let picfile_desc = (<div>Drag an image file here<br/><br/>
    Or click this to open a picture</div>)

    let mobile_banner = null
    let desktop_banner = (<div style={{display:'flex', flexDirection:'row'}}>
                            <div className='demo-lnks'>
                                <a href='https://youtu.be/C1As15J5YDA' target='0'>

                                <div id='demo_header' className='demo-header-box'>
                                    <div className='demo-header-text'>Click to watch a demonstration</div>
                                    <img className='demo-header-pic' alt='demo video' src='demo_vid_pic.png'/>
                                </div>
                                </a>
                            </div>
                        </div>)

    let shade_tree_mobile = null
    let shade_tree = (<div id='shade_tree' className='shade-tree'>

                                    {/* controls for pencil shading tips */}
                                    <div className='shade_group'>

                                        <div id='color_name' className='color_nm_label'></div>
                                        
                                        <div id='color_pane' className='color_pane' style={{height:'154px'}}></div>
                                                            
                                        <div className='tricolor_bar' id='three_shades' style={{display:'none'}}>
                                            <div style={{backgroundColor:'black', width:'10px', height:'10px', marginTop:'6px' }}></div>
                                            <div style={{backgroundColor:'gray', width:'10px', height:'10px', marginTop:'6px' }}></div>
                                            <div style={{backgroundColor:'silver', width:'10px', height:'10px', marginTop:'6px' }}></div>
                                            &nbsp;&nbsp;pencil tips
                                        </div>    

                                        <span id='bw_shades' className='color_label' style={{display:'none'}}></span>
                                        
                                        <center>
                                        <div id='pencil_conf_lnk' style={{display:'none', flexDirection:'row', marginLeft:'32px', marginTop:'22px'}}>
                                            <div className='general-lnk' onClick={this.showPencilConfig}>Configure Pencils
                                            </div>
                                            <div className='help-mark'>?<span className='tooltiptext'>Check what pencils you have available, and only those will be recommended when you click the picture.</span></div>
                                        </div>
                                        </center>

                                    </div>

                                    {/* controls for paint mixing tips */}
                                    <div id='color_shades' style={{marginTop:'25px'}}>
                                        
                                        <div className='tricolor_bar'>
                                            <div style={{backgroundColor:'red', width:'10px', height:'10px', marginTop:'6px' }}></div>
                                            <div style={{backgroundColor:'blue', width:'10px', height:'10px', marginTop:'6px' }}></div>
                                            <div style={{backgroundColor:'yellow', width:'10px', height:'10px', marginTop:'6px'
                                        }}></div>
                                            &nbsp;&nbsp;paint mix tips
                                        </div>

                                        <span id='color_desc' className='color_label'></span>

                                    </div> 



                                </div>)

    if(window.sessionStorage.getItem("device-type") === "small") {
        // swap skyscraper add with banner
        sample_controls = 'sample-ctrls-mo'
        ctrl_area_class = 'ctrl-area-mo'
        policy_class = 'policy_link_mo'
        cookie_class = 'cookie-area-mo'
        home_class = 'home-pic-mo'
        title_class = 'store-header-mo'
        config_pane_class = 'configure-pane-mo'
        mobile_banner = desktop_banner
        desktop_banner = null
        picfile_desc = (<div>Tap here to open a picture</div>)
        shade_tree_mobile = shade_tree
        shade_tree = null
        
    }

    if(window.sessionStorage.getItem("cookie-okayed") === 'ok') {
        cookie_class = 'cookie-hidden'
    }


    return (
    <form  id="drag_files" className="drag-drop" noValidate onDropCapture={(e) => this.onImageChange(e)}>
    
        {/* hint fades IN and OUT over picture after clicking 'finishing' option */}
        <div id='click_hint' className='click-hinter' style={{display:'none'}}>
            Click on the picture
        </div>
        
        {/* mobile sketching/finishing options */}
        <div className='mo-sketching-finishing' id='mo_sketching_finishing'>
            <button className='mo-choice-button' onClick={(e) => this.sketchPic(e)}>
                I am sketching an outline of the picture
            </button>
            <button className='mo-choice-button' onClick={(e) => this.finishPic(e)}>
                I am finishing the picture
            </button>
        </div>

        {/* mobile paint/pencil options */}
        <div className='mo-sketching-finishing' id='mo_paint_pencil'>
            <button className='mo-choice-button' onClick={(e) => this.apply_shade(e, 'pencil', true)}>
                I am using pencil
            </button>
            <button className='mo-choice-button' onClick={(e) => this.apply_shade(e, 'paint', true)}>
                I am painting
            </button>
        </div>

        {/* mobile sketching info */}
        <div className='mo-sketching' id='explain_sketching'>
            
            <button className='mo-explain-button' onClick={(e) => this.explained_sketching_ok(e)}>
            <p>Tap on reference points of the picture to see how to measure them on your paper.</p>
            <p>Hold your paper in {this.state.paper_orientation} mode.</p>
            <div style={{height:'30vh'}}> </div>
                ok
            </button>
        </div>

        {/* mobile finishing info */}
        <div className='mo-sketching' id='explain_finishing'>
            
            <button className='mo-explain-button' onClick={(e) => this.explained_finishing_ok(e)}>
            <p>Tap on the picture to see finishing tips.</p>
            <div style={{height:'30vh'}}> </div>
                ok
            </button>
        </div>


        {/* mobile measure info */}
        <div className='mo-sketching-mm' id='mobile_sketching_mm'>
            
            <button className='mo-explain-button' onClick={(e) => this.showed_mm_ok(e)}>
            
            <div id="mobile_mm"></div>
            <div style={{height:'30vh'}}> </div>
            </button>
        </div>

        {/* mobile finishing tips */}
        <div id='shade_tree_mobile' className='mobile-shade-tree' onClick={(e) => this.clicked_finishing_tree(e)}>
            {shade_tree_mobile}
        </div>
        

        {/* controls column area */}
        <div id='ctrl_area' className={ctrl_area_class}>


            {mobile_banner}


            
            {/* icon at top of column */}
            <img alt='' src='micon.png' style={{width:'200px'}}/> 
           
            {/* sketching / finishing buttons + instruction */}
            <div id='type_buttons' style={{display:'none', marginLeft:'10px'}}>
                <div style={{display:'flex', flexDirection:'row'}}>
                <button className={this.state.mode === 'sketch' ? 'menu_button_sel' : 'menu_button'} id='sketch_button' onClick={(e) => this.sketchPic(e)}>Sketching</button>
                <button className={this.state.mode === 'finish' ? 'menu_button_sel' : 'menu_button'} id='finish_button' onClick={(e) => this.finishPic(e)}>Finishing</button>
                
                </div>
                <div className='whatcha-doin-label' id='whatcha_doin_label'>
                <p/>Click sketching to begin. <p/>If you are already shading or painting then click finishing instead
                </div>
            </div>

            {/* paint / pencil options */}
            <div id='opt_area' className='opt-area' style={{display:'none'}}>
                <input type='radio' onChange={this.switch_shades} value='paint' id='paint_opt' name='shade_type' checked={this.state.shade_type === 'paint'}/>
                <label htmlFor='paint_opt' className='optlabel'>Paint</label>
                
                <input type='radio' onChange={this.switch_shades} value='pencil' id='pencil_opt' name='shade_type' checked={this.state.shade_type === 'pencil'}/>
                <label htmlFor='pencil_opt' className='optlabel'>Pencil</label>    
            </div>

            {/* contrast controls area */}
            <div id='sketch_tree' className='linedrawn-box' style={{display:'none', width:'90%'}}>
                <div style={{backgroundColor:'beige', paddingTop: '15px', border: '1px gold solid'}}>

                    <div style={{display:'flex',flexDirection:'row', marginLeft:'48px', marginBottom:'14px'}}>
                        <input type='checkbox' onChange={this.toggleLinedrawn} checked={this.state.linedrawn}/>
                        <span style={{fontSize:'10pt', color:'brown', marginLeft:'3px', marginTop:'2px'}}> Contrast</span>
                        <div className='help-mark'>?<span className='tooltiptext'>`Contrast` can be used to highlight what areas of your picture need definining.</span></div>

                    </div>
                    
                    <div style={{fontSize:'10pt', display:'flex',flexDirection:'row', marginLeft:'20px', marginBottom:'14px', color:'brown'}}>

                        detail:&nbsp;<input onInput={this.doBlur} className='range-slider' id="gaussianBlurSlider" defaultValue="8" type="range" min="1" max="50" step="any"/>
                    </div>                    
                    <div style={{fontSize:'10pt', display:'flex',flexDirection:'row', marginLeft:'20px', marginBottom:'14px', color:'brown'}}>

                        grains:<input onInput={this.doSharpen} className='range-slider' id="sharpenSlider" type="range" defaultValue="20" min="8.5" max="20" step="any"/>  
                    </div>
						  
                </div>
            </div>
  
            
            {/* panel for displaying measurements */}
            <div id='measures' className='hint-pane'>
                    
                <div id='pic_mm' className='desc_label' style={{height:'330px', display:'none'}}>
                    <div className='desc_label'></div>
                </div>
                <div>
                    <img id='drawing_mode' style={{display:'none'}} alt='drawing-mode' title='Portrait mode' src='portrait_mode.png'/> 

                </div>
                																 
            </div>




            {shade_tree}









            {/* home page control elements */}
            <input id='chooser' style={{display:'none'}} type="file" onChange={this.onImageChange} className="filetype"/>

                    <div className='splash-text' id='splash_text'>
                        
                        <div style={{display:'none', width:'100%', textAlign:'center', marginBottom:'6px'}}>
                            Sketch calculator 
                        </div>
                        
                        <div style={{textAlign: 'center', fontSize: 'small', whiteSpace:'nowrap'}}>
                        with <span style={{color:'darkgray'}}>shade</span>/<span style={{color:'goldenrod'}}>color</span> assist
                        </div>
                    
                        <div id='drag_drop_visible' className='drag-drop-visible' onClick={this.choosePic}>

                            {picfile_desc}

                        </div>
                        

                        <a href='robs_gallery.html'>
                            <img className='gallery-button' alt='gallery' title='view gallery' src='gallery_button.png'/> 
                            <br/>

 
                            <img style={{height:'100px'}} alt='gallery button' title='view gallery' src='gallerythumb.jpg'/>
                        </a>

                        

                        <img style={{marginTop:'12px'}} alt='music' src='playlist_header.png'/>

                        <br/>

 
                        <a href='https://www.youtube.com/playlist?list=PLCM2GsRvfe-MJVCqKlONml7lrJ2L_x3k3' target='0'>
                            <img style={{width:'93px'}} alt='effects playlist' title='view effects playlist on youtube' src='effects_playlist.png'/>
                        </a>
                        <a href='https://www.youtube.com/playlist?list=PLCM2GsRvfe-Nk1mFEQBUWpaQ8SMED7EPa' target='0'>
                            <img style={{width:'93px'}} alt='puzzle playlist' title='view puzzle playlist on youtube' src='puzzle_playlist.png'/>
                        </a>
                        
                        


                        <br/>
                       

                        <a href='https://www.youtube.com/playlist?list=PLCM2GsRvfe-Pv3IAaQaUJsKA_aWucxl1A' target='0'>
                            <img style={{width:'93px'}} alt='firepick playlist' title='view firepick playlist on youtube' src='firepick_playlist.png'/>
                        </a>
                        <a href='https://www.youtube.com/playlist?list=PLCM2GsRvfe-ObYkRG9n5Gp6CINiHK3mlw' target='0'>
                            <img style={{width:'93px'}} alt='duck playlist' title='view duck playlist on youtube' src='duck_playlist.png'/>
                        </a>

                        <br/>



                        <img alt='playlist' src='playlist_footer.png'/>
                        



                    </div>

            

            <div id='cookie_area' className={cookie_class}>
                <div className='cookie-text'>
                    This website uses cookies. For more information click the privacy link below
                </div>
                <div>
                    <button className='cookie-button' onClick={this.hideCookieWarning}>OK</button>
                </div>
                
            </div>
        
            {/* privacy link - bottom of control column */}
            <div className={policy_class} style={{justifyContent:'space-around', display:'flex', flexDirection:'row', flexBasis: ''}}>
            <a href='privacy.html'>Privacy </a><a href='contact.html'>Contact</a>
            </div>
            
        </div>


        {/* configure pencil availability panel */}
        <div className='pencil_pane' id='pencil_pane'>
            <div className='acct-header-config'>Choose which pencils you have on hand</div>
                <div className='acct-header-config-sm'>Only those will be recommended</div>

                <div style={{display:'flex',flexDirection:'row', justifyContent:'space-around', width:'100%'}}>

                    <table>
                        <tbody>
                    <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, '9B')} checked={this.state.pencils && this.state.pencils.indexOf('9B') > -1 ? true : false}/></td>
                            <td>9B</td>
                        </tr>
                        <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, '8B')} checked={this.state.pencils && this.state.pencils.indexOf('8B') > -1 ? true : false}/> </td>
                            <td>8B</td>
                        </tr>
                        <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, '7B')} checked={this.state.pencils && this.state.pencils.indexOf('7B') > -1 ? true : false}/> </td>
                            <td>7B</td>
                        </tr>
                        <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, '6B')} checked={this.state.pencils && this.state.pencils.indexOf('6B') > -1 ? true : false}/> </td>
                            <td>6B</td>
                        </tr>
                        <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, '5B')} checked={this.state.pencils && this.state.pencils.indexOf('5B') > -1 ? true : false}/> </td>
                            <td>5B</td>
                        </tr>
                        <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, '4B')} checked={this.state.pencils && this.state.pencils.indexOf('4B') > -1 ? true : false}/> </td>
                            <td>4B</td>
                        </tr>
                        <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, '3B')} checked={this.state.pencils && this.state.pencils.indexOf('3B') > -1 ? true : false}/> </td>
                            <td>3B</td>
                        </tr>
                        <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, '2B')} checked={this.state.pencils && this.state.pencils.indexOf('2B') > -1 ? true : false}/></td>
                            <td>2B</td>
                        </tr>
                        <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, 'B')} checked={this.state.pencils && this.state.pencils.indexOf('B') > -1 ? true : false}/> </td>
                            <td>&nbsp;B</td>
                        </tr>
                        <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, 'HB')} checked={this.state.pencils && this.state.pencils.indexOf('HB') > -1 ? true : false}/></td>
                            <td>HB</td>
                        </tr>
                        
                        </tbody>
                    </table>

                        
                    <table>
                        <tbody>
                    <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, 'F')} checked={this.state.pencils && this.state.pencils.indexOf('F') > -1 ? true : false}/> </td>
                            <td>&nbsp;F</td>
                        </tr>
                        <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, 'H')} checked={this.state.pencils && this.state.pencils.indexOf('H') > -1 ? true : false}/> </td>
                            <td>&nbsp;H</td>
                        </tr>
                        <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, '2H')} checked={this.state.pencils && this.state.pencils.indexOf('2H') > -1 ? true : false}/> </td>
                            <td>2H</td>
                        </tr>
                        <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, '3H')} checked={this.state.pencils && this.state.pencils.indexOf('3H') > -1 ? true : false}/> </td>
                            <td>3H</td>
                        </tr>
                        <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, '4H')} checked={this.state.pencils && this.state.pencils.indexOf('4H') > -1 ? true : false}/> </td>
                            <td>4H</td>
                        </tr>
                        <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, '5H')} checked={this.state.pencils && this.state.pencils.indexOf('5H') > -1 ? true : false}/> </td>
                            <td>5H</td>
                        </tr>
                        <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, '6H')} checked={this.state.pencils && this.state.pencils.indexOf('6H') > -1 ? true : false}/> </td>
                            <td>6H</td>
                        </tr>
                        <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, '7H')} checked={this.state.pencils && this.state.pencils.indexOf('7H') > -1 ? true : false}/> </td>
                            <td>7H</td>
                        </tr>
                        <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, '8H')} checked={this.state.pencils && this.state.pencils.indexOf('8H') > -1 ? true : false}/> </td>
                            <td>8H</td>
                        </tr>
                        <tr>
                            <td><input className='pencil-chk' type='checkbox' onChange={(e) => this.setPencil(e, '9H')} checked={this.state.pencils && this.state.pencils.indexOf('9H') > -1 ? true : false}/> </td>
                            <td>9H</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
    

            <div style={{marginTop:'20px'}}>

                <button id='config_pencil_ok' onClick={(e) => this.pencil_ok(e)} className='menu_button'>OK</button>
                
                <span className='general-txt' style={{marginLeft:'40px', marginRight:'10px'}}>check</span> <span className='general-lnk' onClick={() => this.checkPencils('all')}>all</span> <span className='general-txt'>:</span> <span className='general-lnk' onClick={() => this.checkPencils('none')}>none</span>

                <div className='warning-txt' id='pencil_warning'>&nbsp;</div>
            </div>
        </div>


        {/* configure paper dimension panel */}
        <div className={config_pane_class} id='config_pane'>
            
            <div className='acct-header-config'>
                Set your paper size and margin width
            </div>
            <div className='acct-header-config-sm'>
                Your sketch will fill the page
            </div>

            <div className='configure_row' style={{textAlign:'right'}}>

                <select id='common_paper_sz' className='config_element' onChange={this.choose_common_paper}>
                    <option value=''>Common sizes</option>
                    <option value='110 x 150'>4 x 6 inches  - 110 x 150 mm</option>
                    <option value='152 x 178'>5 x 7 inches  - 152 x 178 mm</option>
                    <option value='152 x 203'>6 x 8 inches  - 152 x 203 mm</option>
                    <option value='203 x 254'>8 x 10 inches  - 203 x 254 mm</option>
                    <option value='254 x 254'>10 × 10 inches - 254 x 254 mm</option>
                    <option value='279 x 356'>11 x 14 inches - 279 x 356 mm</option>
                    <option value='305 x 305'>12 × 12 inches - 305 x 305 mm</option>
                    <option value='305 x 406'>12 × 16 inches - 305 x 406 mm</option>
                    <option value='356 x 356'>14 × 14 inches - 356 x 356 mm</option>
                </select>
                <div className='config_element'>
                <label htmlFor='paper_size_w'>Paper Width</label>
                <input className='number-entry' placeholder='203' type='number' id='paper_size_w' style={{width:'55px', marginLeft:'4px', marginRight:'4px'}} /><label>mm</label>
                </div>

                <div className='config_element'>
                <label htmlFor='paper_size_h'>Height</label>
                <input className='number-entry' placeholder='254' type='number' id='paper_size_h' style={{width:'55px', marginLeft:'4px', marginRight:'4px'}} /><label>mm</label>
                </div>
                
                
                
                
            </div>
            <div className='configure_row'>
                <div className='config_element'>
                    <label htmlFor='margin_size'>Margin Width</label>
                    <input className='number-entry' placeholder='20' type='number' id='margin_size' style={{width:'55px', marginRight:'4px'}}/><label>mm</label>
                </div>
            <div className='warning-txt' id='paper_warning'>&nbsp;</div>
            <button id='config_ok' onClick={(e) => this.config_ok(e)} className='menu_button' style={{marginRight:'4px', marginLeft:'220px', marginTop:'20px'}}>OK</button>

            </div>

        </div>


        {/* image display area */}
        <div className='split-parent'>

            <div id='wk_area' className='work_area'>

                <div id='pic_load_info'>Loading Picture..</div>

                <div className='splash_area' id='splash'>

                        <div className='splash-pic'>

                        </div>
                    
                </div>

                <div style={{position:'absolute'}} id="file_target" className="drag-files-label">
                    <div id='close_pic_button' style={{position:'absolute', display:'none', flexDirection:'row'}}>
                        <span className='banner_button' id='go_sketching' onClick={this.sketchPic} style={{display: 'none'}}>Sketching</span>
                        <span className='banner_button' id='go_finishing' onClick={this.finishPic} style={{display: 'none'}}>Finishing</span>
                        <span className='banner_button' onClick={this.closePic}>X</span>
                    </div>
                    <canvas className='pic-canvas' id="target" onClick={this.onPicClick}></canvas>
                </div>

                {/* required for 'contrast' filtering */}
                <svg >
                <defs>
                
                    <filter width="100" height="100" id="line-art" colorInterpolationFilters="sRGB">
                    <feColorMatrix in="SourceGraphic" type="matrix" values="-1 0 0 0 1 
                                                                            0 -1 0 0 1 
                                                                            0 0 -1 0 1
                                                                            0 0 0 1 0" result="inverted"/>
                    <feGaussianBlur id="gaussianBlur" in="inverted" stdDeviation="8" result="inverted-blurred"/>
                    <feBlend in="SourceGraphic" in2="inverted-blurred" mode="color-dodge" result="colorDodge"/>
                    
                    <feColorMatrix type="saturate" values="0"/>      

                    <feConvolveMatrix id="fesharpen" order="3" kernelMatrix="-1 -1 -1 -1 8.5 -1 -1 -1 -1"/>
                
                    </filter>
                    
                </defs>
                </svg>

            </div>

            

        </div>
        
        {/* title - shows over picture */}
        <div className='header-boundary home-content' id='header_boundary'>
            <span className={title_class}>{title}</span>
            <span style={{width:'89%'}}>..</span>
        </div>

        {/* home column area */}
        <div id='demo_boundary' className='home-content' style={{textAlign:'left'}}>

            {/* demo header banner */}
            {desktop_banner}

            {/* homepage picture */}
            <div className={home_class} id='home_pic'>
                <img alt='' id='demo_image' src='sunset.jpg' style={{minWidth:'300px'}}/>
            </div>

            

            {/* controls for navigating and selecting sample picture */}
            <div className={sample_controls}>  
                <span id='nav_desc'>Try a sample picture</span>
                <div onClick={(e) => this.navSampleBack(e)} className='sample_nav_btn'>&lt;</div> &nbsp;<div className='btn-begin' onClick={(e) => this.draw_sample(e)}>start</div>&nbsp; <div className='sample_nav_btn' onClick={(e) => this.navSampleFwd(e)}>&gt;</div>
            </div>

            
        </div>


    </form>
    );
    }
}
  
export default Outline;